import angular from 'angular';
import cutoffPaymentsDialogTemplate from './cutoffPaymentsDialog.template.html';
import CSMCommonWeb from 'csm-common-web';

/*******************************************************************************
 * @ngdoc  module
 * @name   csm.books.com.returnItems.cutoffPaymentsDialog
 * @description
 * Lists the payments on a receipt that can't be refunded because they were
 * made before the 11.0.0 release (see the server's Receivables.
 * getPaymentsBeforeRefundCutoff), so the user knows exactly which ones the
 * Returns screen left out. Read-only - returnItems.js's getReceipt opens it
 * on load, and the only thing to do is close it.
 *******************************************************************************/
export default angular
  .module('csm.books.com.returnItems.cutoffPaymentsDialog', [
    CSMCommonWeb,
    'ui.bootstrap',
    'ui.grid'
  ])
  .service('CutoffPaymentsDialog', DialogControllerService)
  .component('cutoffPaymentsDialog', cutoffPaymentsDialogComponent()).name;

/*******************************************************************************
 * DialogControllerService */
/**
 * Opens the dialog for the given payments. Resolves however it closes (Close
 * or Esc), so the caller can carry on either way.
 *******************************************************************************/
/* @ngInject */ function DialogControllerService($uibModal) {
  this.show = function (payments) {
    const done = angular.noop;

    return $uibModal
      .open({
        backdrop: 'static',
        component: 'cutoffPaymentsDialog',
        resolve: { payments: () => payments },
        size: 'lg'
      })
      .result.then(done, done);
  };
}

/*******************************************************************************
 * cutoffPaymentsDialogComponent */
/**
 * Component definition for the cutoff payments dialog.
 *******************************************************************************/
/* @ngInject */ function cutoffPaymentsDialogComponent() {
  return {
    bindings: { resolve: '<', modalInstance: '<' },
    controller: Controller,
    template: cutoffPaymentsDialogTemplate
  };
}

/*******************************************************************************
 * Controller */
/**
 * Controller for the cutoff payments dialog.
 *******************************************************************************/
/* @ngInject */ function Controller(SERVER, Tools, uiGridConstants) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.message = SERVER.BooksDBConstants.PAYMENT_REFUND_CUTOFF_MSG;
    $ctrl.payments = $ctrl.resolve.payments;
    $ctrl.total = Tools.roundMoney(
      $ctrl.payments.reduce(function (total, payment) {
        return total + payment.amount;
      }, 0)
    );

    $ctrl.paymentsGrid = {
      enableColumnMenus: false,
      enableSorting: false,
      enableFiltering: false,
      enableRowSelection: false,
      enableFullRowSelection: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableSelectAll: false,
      enableColumnResizing: false,
      enableGridMenu: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      minRowsToShow: Math.min($ctrl.payments.length, 10) || 1,
      data: $ctrl.payments,
      columnDefs: [
        { field: 'name', displayName: 'For', cellTooltip: true },
        { field: 'memo', displayName: 'Payment', cellTooltip: true },
        {
          field: 'entryDate',
          displayName: 'Date',
          cellFilter: "date:'MM/dd/yyyy'",
          width: 110
        },
        {
          field: 'amount',
          displayName: 'Amount',
          cellFilter: 'currency',
          width: 120,
          cellClass: 'text-right'
        },
        { field: 'receiptNumber', displayName: 'Receipt', width: 130 }
      ]
    };
  };
}
